export default defineNuxtRouteMiddleware(() => {
  const user = useAuthUser()
  const localePath = useLocalePath()

  if (user.value) {
    return navigateTo(localePath("/users/profile"))
  }
})
